class CartNotification extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.style.cssText = 'display:none!important;visibility:hidden!important;pointer-events:none!important;position:absolute!important;left:-9999px!important;opacity:0!important;height:0!important;overflow:hidden!important;';
  }

  open() {
    if (typeof satoriCartOpen === 'function') {
      satoriCartOpen();
    }
  }

  close() {}

  renderContents(parsedState) {
    if (typeof satoriCartOpen === 'function') {
      satoriCartOpen();
    }
  }

  getSectionsToRender() {
    return [];
  }

  getSectionInnerHTML(html, selector) {
    return '';
  }

  handleBodyClick(evt) {}

  setActiveElement(element) {}
}

customElements.define('cart-notification', CartNotification);